/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetMenuAvailability200Response,
  GetProductStock200Response,
  GetProductsStock200ResponseInner,
  UpdateMenuAvailabilityRequest,
  UpdateProductStockRequest,
} from '../models/index';
import {
    GetMenuAvailability200ResponseFromJSON,
    GetMenuAvailability200ResponseToJSON,
    GetProductStock200ResponseFromJSON,
    GetProductStock200ResponseToJSON,
    GetProductsStock200ResponseInnerFromJSON,
    GetProductsStock200ResponseInnerToJSON,
    UpdateMenuAvailabilityRequestFromJSON,
    UpdateMenuAvailabilityRequestToJSON,
    UpdateProductStockRequestFromJSON,
    UpdateProductStockRequestToJSON,
} from '../models/index';

export interface DeleteProductStockRequest {
    productId: string;
}

export interface GetProductStockRequest {
    productId: string;
}

export interface UpdateMenuAvailabilityOperationRequest {
    locationId: string;
    itemId: string;
    type: UpdateMenuAvailabilityTypeEnum;
    updateMenuAvailabilityRequest: UpdateMenuAvailabilityRequest;
}

export interface UpdateProductStockOperationRequest {
    productId: string;
    updateProductStockRequest: UpdateProductStockRequest;
}

/**
 * 
 */
export class CatalogsApi extends runtime.BaseAPI {

    /**
     */
    async deleteProductStockRaw(requestParameters: DeleteProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling deleteProductStock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/stock/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteProductStock(requestParameters: DeleteProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProductStockRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getCatalogsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getCatalogs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getCatalogsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMenuAvailabilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMenuAvailability200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/availability/menu-availability`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMenuAvailability200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getMenuAvailability(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMenuAvailability200Response> {
        const response = await this.getMenuAvailabilityRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductStockRaw(requestParameters: GetProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProductStock200Response>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling getProductStock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/stock/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProductStock200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProductStock(requestParameters: GetProductStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProductStock200Response> {
        const response = await this.getProductStockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductsStockRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetProductsStock200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/stock/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetProductsStock200ResponseInnerFromJSON));
    }

    /**
     */
    async getProductsStock(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetProductsStock200ResponseInner>> {
        const response = await this.getProductsStockRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateMenuAvailabilityRaw(requestParameters: UpdateMenuAvailabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling updateMenuAvailability().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling updateMenuAvailability().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling updateMenuAvailability().'
            );
        }

        if (requestParameters['updateMenuAvailabilityRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMenuAvailabilityRequest',
                'Required parameter "updateMenuAvailabilityRequest" was null or undefined when calling updateMenuAvailability().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/availability/locations/{locationId}/{type}/{itemId}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters['locationId']))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId']))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMenuAvailabilityRequestToJSON(requestParameters['updateMenuAvailabilityRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateMenuAvailability(requestParameters: UpdateMenuAvailabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMenuAvailabilityRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateProductStockRaw(requestParameters: UpdateProductStockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling updateProductStock().'
            );
        }

        if (requestParameters['updateProductStockRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProductStockRequest',
                'Required parameter "updateProductStockRequest" was null or undefined when calling updateProductStock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/stock/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProductStockRequestToJSON(requestParameters['updateProductStockRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateProductStock(requestParameters: UpdateProductStockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProductStockRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const UpdateMenuAvailabilityOperationTypeEnum = {
    Products: 'products',
    Combos: 'combos',
    Modifiers: 'modifiers',
    ModifierGroups: 'modifier_groups'
} as const;
export type UpdateMenuAvailabilityOperationTypeEnum = typeof UpdateMenuAvailabilityOperationTypeEnum[keyof typeof UpdateMenuAvailabilityOperationTypeEnum];
